import { apiClient } from './client';

export function getSettingsAudit (shopId: number | string, params: Record<string, unknown>) {
  return apiClient.get(`/${shopId}/audit/shop-settings`, { params });
}
